import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  target?: string;
  rel?: string;
  variant?: 'primary' | 'secondary';
}
export function Button({
  children,
  href,
  target,
  rel,
  variant = 'primary',
  className = '',
  ...props
}: ButtonProps) {
  const baseClass = 'inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-semibold text-lg md:text-xl transition-colors shadow-warm w-full md:w-auto text-center';
  const variants = {
    primary: 'bg-forest text-white hover:bg-sage',
    secondary: 'bg-warm-white text-forest border-2 border-forest hover:bg-cream'
  };
  const content = <>
      {children}
      <ArrowRight className="w-5 h-5 flex-shrink-0" data-id="element-196" />
    </>;
  if (href) {
    return <motion.a href={href} target={target} rel={rel} className={`${baseClass} ${variants[variant]} ${className}`} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-197">
        {content}
      </motion.a>;
  }
  return <motion.button className={`${baseClass} ${variants[variant]} ${className}`} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-198">
      {content}
    </motion.button>;
}